// import { isMobile, isTablet } from "react-device-detect";
import { useIsMounted } from "@pancakeswap/hooks";
import React from "react";
import { useMatchBreakpoints } from "../../contexts";
import { Box, Flex } from "../Box";
// import { Link } from "../Link";
// import {
//   StyledFooter,
//   StyledIconMobileContainer,
//   StyledList,
//   StyledListItem,
//   StyledSocialLinks,
//   StyledText,
//   StyledToolsContainer,
// } from "./styles";

// import { vars } from "../../css/vars.css";
// import { Button } from "../Button";
// import CakePrice from "../CakePrice/CakePrice";
// import LangSelector from "../LangSelector/LangSelector";
import { ArrowForwardIcon, LogoIcon, LogoWithTextIcon } from "../Svg";
import { FooterProps } from "./types";
import { Text } from "../Text";
import { StyledFooter, StyledSocialLinks } from "./styles";
import { useTranslation } from "@pancakeswap/localization";

const MenuItem: React.FC<React.PropsWithChildren<FooterProps>> = ({
  items,
  isDark,
  toggleTheme,
  currentLang,
  langs,
  setLang,
  cakePriceUsd,
  buyCakeLabel,
  buyCakeLink,
  chainId,
  showLangSelector = true,
  showCakePrice = true,
  ...props
}) => {
  const isMounted = useIsMounted();
  const { isXl } = useMatchBreakpoints();
  const { t } = useTranslation();

  return (
    <StyledFooter
      data-theme="dark"
      p={["16px 23px", null, "16px 23px"]}
      position="relative"
      {...props}
      justifyContent="center"
    >
      <Flex flexDirection={["column", null, null, "row"]} justifyContent="space-between" width={["100%", null, "100%"]}>
        {/* Powered By Text and Logo Start */}
        <Flex
          alignItems="center"
          flexDirection={["column", null, "row"]}
          justifyContent={["center", null, null, "start"]}
        >
          <Text fontSize="15px" color="#6FC7BA">
            {t("Powered By")}
          </Text>
          <Box borderRight="1px solid #fff" height="100%" mx={["0", null, "20px"]} mt={["8px", null, "0"]} />
          <Box>
            <LogoWithTextIcon width="200px" />
          </Box>
        </Flex>
        {/* Powered By Text and Logo End */}

        {/* Socials Start */}
        <Flex justifyContent={["center", null, null, "end"]} mt={["20px", null, null, "0px"]}>
          <StyledSocialLinks order={[2]} />
        </Flex>
        {/* Socials End */}
      </Flex>
    </StyledFooter>
  );
};

export default MenuItem;
